import { Component, OnInit } from '@angular/core'
import { ApiService, UserInfo } from '../../../services/api.service'
import { ButtonComponent } from '@components/button/button.component'
import { CommonModule } from '@angular/common'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component'
import { Router } from '@angular/router'
import { LinkComponent } from '@components/link/link.component'
import { HomeLinksService } from '../../../services/home-links.service'



interface LeadStats {
  newCustomers: number;
  unconfirmed: number;
  oppInProgress: number;
  almostComplete: number;
  total: number;
}
@Component({
    selector: 'app-leads-block-2026',
    templateUrl: './leads-block-2026.component.html',
    imports: [ButtonComponent, CommonModule, TranslateModule, CosentinoSvgComponent, LinkComponent],
    standalone: true,
    styleUrl: './leads-block-2026.component.scss',
})
export class LeadsBlock2026 implements OnInit {
    userInfo?: UserInfo
    leadsStats?: LeadStats

    constructor(private api: ApiService, private homeLinksService: HomeLinksService) {}

    ngOnInit(): void {
        this.api.userInfo.subscribe((userInfo) => {
            this.userInfo = userInfo
            if(this.userInfo && this.userInfo.id){
                this.api.getLeadStats().subscribe((stats) => {
                    this.leadsStats = stats
                })
            }
        })
    }
    goToLeads(status?: string) {
        this.homeLinksService.goToLeads(status)
    }
}